var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect, useState } from 'react';
import { isEqual, noop } from 'lodash';
import { useLocalStorage, writeStorage } from '@rehooks/local-storage';
import { Loading, MultiColumnList, Row } from '@folio/stripes/components';
// @ts-ignore:next-line
import { PrevNextPagination, usePagination } from '@folio/stripes-acq-components';
import { listTableMapping } from './helpers/mappers';
import { listTableResultFormatter } from './helpers/formatters';
import { LISTS_VISIBLE_COLUMNS } from '../../constants';
import { useLists, useListsIdsToTrack, usePrevious } from '../../hooks';
import { CURRENT_PAGE_OFFSET_KEY, PAGINATION_AMOUNT } from '../../utils/constants';
import { columnWidthsConfig } from './configs';
export var ListsTable = function (_a) {
    var activeFilters = _a.activeFilters, _b = _a.setTotalRecords, setTotalRecords = _b === void 0 ? noop : _b;
    var storedCurrentPageOffset = useLocalStorage(CURRENT_PAGE_OFFSET_KEY, 0)[0];
    var _c = useState([]), recordIds = _c[0], setRecordIds = _c[1];
    var _d = usePagination({
        limit: PAGINATION_AMOUNT,
        offset: storedCurrentPageOffset,
    }), changePage = _d.changePage, pagination = _d.pagination;
    var goToLastPage = function (totalPages) {
        if (totalPages === void 0) { totalPages = 0; }
        var lastPageOffset = totalPages > 1
            ? PAGINATION_AMOUNT * (totalPages - 1)
            : 0;
        onNeedMoreData({
            offset: lastPageOffset
        });
    };
    var onNeedMoreData = function (thePagination) {
        console.log(thePagination);
        writeStorage(CURRENT_PAGE_OFFSET_KEY, thePagination.offset);
        // @ts-ignore:next-line
        changePage(thePagination);
        setRecordIds([]);
    };
    var prevActiveFilters = usePrevious(activeFilters);
    useEffect(function () {
        if (prevActiveFilters && !isEqual(prevActiveFilters, activeFilters)) {
            writeStorage(CURRENT_PAGE_OFFSET_KEY, 0);
            // @ts-ignore:next-line
            changePage({ offset: 0, limit: PAGINATION_AMOUNT });
            setRecordIds([]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeFilters]);
    var _e = useLists({ filters: activeFilters, size: pagination === null || pagination === void 0 ? void 0 : pagination.limit, offset: pagination === null || pagination === void 0 ? void 0 : pagination.offset }), listsData = _e.listsData, isLoading = _e.isLoading;
    useEffect(function () {
        var _a;
        if (isLoading) {
            return;
        }
        if ((_a = listsData === null || listsData === void 0 ? void 0 : listsData.content) === null || _a === void 0 ? void 0 : _a.length) {
            setRecordIds(listsData === null || listsData === void 0 ? void 0 : listsData.content.map(function (_a) {
                var id = _a.id;
                return id;
            }));
        }
        else if (listsData === null || listsData === void 0 ? void 0 : listsData.totalPages) {
            goToLastPage(listsData === null || listsData === void 0 ? void 0 : listsData.totalPages);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [listsData]);
    var updatedListsData = useListsIdsToTrack({ idsToTrack: recordIds }).updatedListsData;
    if (isLoading) {
        return (React.createElement(Row, { center: "xs" },
            React.createElement(Loading, { size: "large" })));
    }
    var _f = listsData !== null && listsData !== void 0 ? listsData : {}, _g = _f.totalRecords, totalRecords = _g === void 0 ? 0 : _g, totalPages = _f.totalPages;
    var content = (listsData !== null && listsData !== void 0 ? listsData : {}).content;
    if (updatedListsData === null || updatedListsData === void 0 ? void 0 : updatedListsData.content) {
        content = updatedListsData.content;
    }
    setTotalRecords(totalRecords);
    return (React.createElement(React.Fragment, null,
        React.createElement(MultiColumnList, { interactive: true, "data-testid": "ItemsList", contentData: content !== null && content !== void 0 ? content : [], columnWidths: columnWidthsConfig, visibleColumns: LISTS_VISIBLE_COLUMNS, formatter: listTableResultFormatter, pageAmount: totalPages, totalCount: totalRecords, columnMapping: listTableMapping }),
        React.createElement(PrevNextPagination, __assign({}, pagination, { totalCount: totalRecords, onChange: onNeedMoreData }))));
};
